
import Link from "next/link";
import { useTranslations } from 'next-intl';
import Image from "next/image";
import { usePathname } from "next/navigation";

export default function NavigationInfoMenu({ handleLinkClick, infoMenu, lang }) {
  const t = useTranslations('common');
  const pathname = usePathname();
  

  const countries = [
    { code: 'pt', name: 'Portugal', alt:"Bandeira de Portugal", flag: '/icons/flags/pt.svg', url: 'https://doutorapostas.pt/' },
    { code: 'br', name: 'Brasil',  alt:"Bandeira de Brasil", flag: '/icons/flags/br.svg', url: 'https://doutorapostas.com/' },
    { code: 'pe', name: 'Peru', alt:"Bandeira do Peru", flag: '/icons/flags/pe.svg', url: 'https://doctorapuestas.pe/' },
    { code: 'cl', name: 'Chile', alt:"Bandeira do Chile", flag: '/icons/flags/cl.svg', url: 'https://doctorapuestaschile.com/' },
    { code: 'ar', name: 'Argentina', alt:"Bandeira da Argentina", flag: '/icons/flags/ar.svg', url: 'https://doctorapuestasargentina.com/' },
    { code: 'mx', name: 'Mexico', alt:"Bandeira do Mexico", flag: '/icons/flags/mx.svg', url: 'https://doctorapuestas.mx/' },
  ];

  const siteLanguage = lang?.split('-')[1]?.toLowerCase();
  const sortedCountries = [...countries].sort((a, b) => {
    if (a.code === siteLanguage) return -1;
    if (b.code === siteLanguage) return 1;
    return 0;
  });

  return (
    <div className="flex flex-col gap-6">
      <ul className="grid grid-cols-2 gap-1">
        {sortedCountries.map((country, index) => (
          <li
            key={index}
            className={`flex gap-3 items-center ${
              country.code === siteLanguage ? 'bg-white text-black/90 lg:text-white lg:bg-card font-medium' : 'bg-dark lg:bg-card-foreground'
            } cursor-pointer hover:bg-card p-1 rounded-full`}
          >
            <Link href={country.url} className="flex items-center gap-3 w-full hover:scale-[101%]" target="_BLANK">
                <Image src={country.flag} width="18" height="18" alt={country.alt} />
                <span className="text-xs ">{country.name}</span>
            </Link>
          </li>
        ))}
      </ul>
      <nav>
        <menu className="flex flex-col gap-3">
          {infoMenu?.map((entry, index) => {
            const isActive = pathname == entry.url;
            return (<li key={index} className="group">
              <Link
                className={`${isActive ? 'opacity-100': 'opacity-40'} flex gap-1.5 items-center text-xs  duration-200 hover:opacity-85 font-normal`}
                href={entry.url}
                onClick={handleLinkClick}
                rel={entry.rel}
                target={entry.target}
              >
                <span className="hover:text-white leading-none">{entry.anchor}</span>
              </Link>
            </li>)}
          )}
        </menu>
      </nav>
      <div className="flex items-center gap-2 border-white/5   rounded-lg text-xs font-medium justify-center w-auto text-white px-3 py-2 bg-dark lg:bg-card-foreground">
        <span className="text-green font-extrabold">+18</span>
        <span className="opacity-80">{t('playResponsible')}</span>
      </div>
    </div>
  );
}
